import styled from 'styled-components';
import { layout } from 'src/components/base';
import { IconMagnifier } from '@prisjakt/ui/icon/magnifier';

export const SearchIcon = styled(IconMagnifier).attrs(() => ({
  color: 'base300',
}))``;

export const IconButton = styled.button`
  position: absolute;
  right: 10px;
  top: 10px;
`;

export const SearchInput = styled.input`
  width: 100%;
  margin: 0;
  display: block;
  outline: none;
  cursor: text;
  padding: ${layout.measurements.spacing050};
  border: 1px solid ${p => p.theme.colors.base300};
  border-radius: 5px;

  &:focus {
    border-color: ${p => p.theme.colors.maybeBlue700};
    box-shadow: inset 0 0 0 1px ${p => p.theme.colors.maybeBlue700};
  }
`;
